import { defineMessages } from 'react-intl';

export default defineMessages({
    reductionOfCoverage: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.components.WMICPAPolicyDriverEndorsements.WMICPAPolicyDriverEndorsements.reductionOfCoverage',
        defaultMessage: '28 - Reduction of Coverage when Vehicle Operated by Named Drivers',
    },
    reductionOfCoverage_AB_YT: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.components.WMICPAPolicyDriverEndorsements.WMICPAPolicyDriverEndorsements.reductionOfCoverage_AB_YT',
        defaultMessage: '28(C) - Named Person(s) Reduction of Coverage Endorsement',
    },
    excludedDriver: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.components.WMICPAPolicyDriverEndorsements.WMICPAPolicyDriverEndorsements.Excluded Driver',
        defaultMessage: '28A - Excluded Driver',
    },
});
